export default {
  methods: {
    getRefElement (elem) {
      if (typeof elem === 'object' && Array.isArray(elem)) {
        return elem.length ? elem[0] : []
      }
      return elem
    },
    handleCodeInput (index, e) {
      // check if number, and if not don't allow input
      const numRegex = new RegExp('[^0-9]', 'g')
      if (numRegex.test(e)) {
        this.securityCode[index - 1] = ''
        return
      }

      if (this.securityCode[index - 1] && index < this.inputFieldsCount) {
        this.getRefElement(this.$refs['input' + (index + 1)]).focusIn()
        this.getRefElement(this.$refs['input' + (index + 1)]).selectText()
      } else {
        setTimeout(() => {
          this.getRefElement(this.$refs.submitBtn).$el.focus()
        }, 10)
      }

      this.formInvalid = false
      if (this.$props && this.$props.userInfo && this.$props.userInfo.securityCodeActive) {
        this.$refs.securityCodeChangeObs.reset()
      } else {
        this.$refs.securityCodeObs.reset()
      }
    },
    handleKeyboardPaste (e) {
      const clipboardContent = (e.clipboardData || window.clipboardData).getData('text')
      let validContent = ''
      if (clipboardContent) {
        validContent = clipboardContent.replace(/[^0-9]/g, '').substr(0, 6)
      }

      if (validContent) {
        setTimeout(() => {
          this.securityCode = [...validContent]
          this.handleCodeInput(this.securityCode.length)
        }, 0)
      }
    },
    isFormInvalid (errorsObj) {
      return Object.values(errorsObj).some(entry => entry.length)
    }
  }
}
